module.exports = __webpack_public_path__ + "static/walker-technologies-text.1ac45dd5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/walker-technologies-text.svg
// module id = 369
// module chunks = 114276838955818